import { makeStyles } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';

const partiallyAvailableStyles = makeStyles(theme => createStyles({
  block: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 12px',
    backgroundColor: theme.palette.colors.lightYellow,
    borderRadius: theme.spacing(1),
    minWidth: 230,
    [theme.breakpoints.down('sm')]: {
      minWidth: 'max-content',
    },
  },
  right: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  partially: {
    color: theme.palette.warning.main,
  },
  iconClock: {
    marginRight: theme.spacing(1),
    color: theme.palette.warning.main,
  },
}));

export default partiallyAvailableStyles;
